import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import { CortexTerminal, CortexCommandCentreV2, CortexAdventure, DocumentViewer } from './components/cortex'
import { VortexTerminal, VortexCommandCentre } from './components/vortex'
import { JoyrideRaceBrief } from './components/race/JoyrideRaceBrief'

const TaglinePreview = lazy(() => import('./components/TaglinePreview'))

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/cortex" element={<CortexAdventure />} />
        <Route path="/cortex/demo" element={<CortexAdventure />} />
        <Route path="/cortex/terminal" element={<CortexTerminal />} />
        <Route path="/vortex" element={<VortexTerminal />} />
        <Route path="/joyride" element={<JoyrideRaceBrief />} />
        <Route path="/cortex/command-centre" element={<CortexCommandCentreV2 />} />
        <Route path="/vortex/command-centre" element={<VortexCommandCentre />} />
        <Route path="/cortex/:docType" element={<DocumentViewer />} />
        <Route path="/tagline-preview" element={
          <Suspense fallback={<div className="min-h-screen bg-[#050505]" />}>
            <TaglinePreview />
          </Suspense>
        } />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
